import {
  ArrayField,
  BooleanField,
  ChipField,
  Datagrid,
  DateField,
  DeleteButton,
  EditButton,
  ImageField,
  NumberField,
  ResourceComponentProps,
  Show,
  ShowActionsProps,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";
import { MachineDefinitionTelemetryGroupShow } from "./groups/MachineDefinitionTelemetryGroupShow";

const MachineDefinitionShowActions = (props: ShowActionsProps) => (
  <TopToolbar>
    <EditButton basePath={props.basePath} record={props.data} />
    <DeleteButton basePath={props.basePath} record={props.data} />
  </TopToolbar>
);

export const MachineDefinitionShow = (props: ResourceComponentProps) => (
  <Show actions={<MachineDefinitionShowActions />} {...props}>
    <TabbedShowLayout>
      <Tab label="Sources">
        <TextField source="name" />
        <TextField source="type" />
        <ImageField source="image" />
        <DateField source="createdAt" />
        <DateField source="lastUpdatedAt" />

        <ArrayField source="telemetry">
          <Datagrid>
            <TextField source="name" />
            <TextField source="label" />
            <TextField source="unit" />
            <ChipField source="type" />
            <ChipField source="dataType" />
            <BooleanField source="log" />
            <BooleanField source="sms" />
            <TextField label={"Group"} source="group.name" />
          </Datagrid>
        </ArrayField>
      </Tab>

      <Tab label="Groups">
        <MachineDefinitionTelemetryGroupShow {...props} />
      </Tab>

      <Tab label="Alarms">
        <ArrayField source="alarms">
          <Datagrid>
            <TextField source={"id"} label={"Telemetry Id"} />
            <ArrayField source="definition" label={"Definition"}>
              <Datagrid>
                <TextField source="name" />
                <TextField source="text" />
                <BooleanField source="sms" />
              </Datagrid>
            </ArrayField>
          </Datagrid>
        </ArrayField>
      </Tab>

      <Tab label="Notifications">
        <ArrayField source="notifications">
          <Datagrid>
            <TextField source={"id"} label={"Telemetry Id"} />
            <ArrayField source="definition" label={"Definition"}>
              <Datagrid>
                <TextField source="name" />
                <TextField source="text" />
                <BooleanField source="sms" />
              </Datagrid>
            </ArrayField>
          </Datagrid>
        </ArrayField>
      </Tab>

      <Tab label="Graphs">
        <ArrayField source="graphs">
          <Datagrid>
            <TextField source="label" label="label" />
            <TextField source="valueFormatter" label="Value Formatter" />
            <NumberField source="lastMinutes" label="Show last minutes" />
            <BooleanField source="fullWidth" label="Full Width" />
            <ChipField source="graphType" label="Graph Type" />
            <ArrayField source="dataSources" label="Sources">
              <Datagrid>
                <TextField source="sensorId" />
                <TextField source="color" />
              </Datagrid>
            </ArrayField>
          </Datagrid>
        </ArrayField>
      </Tab>

    </TabbedShowLayout>
  </Show>
);
